import { render, staticRenderFns } from "./ReferralReminder.vue?vue&type=template&id=1f362264&scoped=true&"
import script from "./ReferralReminder.vue?vue&type=script&lang=js&"
export * from "./ReferralReminder.vue?vue&type=script&lang=js&"
import style0 from "./ReferralReminder.vue?vue&type=style&index=0&id=1f362264&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f362264",
  null
  
)

export default component.exports